export default "/images/vendor/flag-icon-css/flags/4x3/al.svg?3dd8853b91d6f490b4c1429d31c80dee";